module.exports = __webpack_public_path__ + "img/article2-2.bdb67cdb.png";